import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { zodPaginatedResponseSchema } from '@vestigas/data';

import { zodCompanyAliasAddressSchema } from '../validations';

export const zodCompanyAliasAddressesSearchParametersSchema = z.object({
  companyId: z.uuid().optional(),
  limit: z.coerce
    .number()
    .positive()
    .max(500)
    .optional()
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT)
    .catch(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.coerce.number().nonnegative().optional().prefault(0).catch(0),
  searchString: z.string().trim().optional(),
});

export const zodCompanyAliasAddressesResponseSchema =
  zodPaginatedResponseSchema(zodCompanyAliasAddressSchema);
